/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from "vue-property-decorator";
import { UserModule } from '@/store/modules/user'
import { getDepartmentByUserId,payInfoList, getBranchList } from '@/api/common'
import {
    setFinanceCommission,
    getFinanceOrderMarketCooperationList,
    getFinanceOrderByMarketCooperationId,
    getFinanceBackMoneyInfoById,
    setPayeeInfo,
    setFinanceCommissionById
} from '@/api/financial-center'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import { getDraftById, setDraftById } from '@/api/draft'
import { delNullProperty } from "@/utils";

Vue.directive('el-select-loadmore1', { // 指令懒加载
    // bind表示这个自定义指令一绑定到dom上，就开始自动执行
    bind(el: any, binding: any) {
        // 获取element-ui定义好的scroll盒子
        const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
        SELECTWRAP_DOM.addEventListener('scroll', function () {
            /**
            * scrollHeight 获取元素内容高度(只读)
            * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
            * clientHeight 读取元素的可见高度(只读)
            * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
            * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
            */
             const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
            if (condition) {
                binding.value();
            }
        });
    },
    // 表示dom插入到页面上的时候自动执行
    // 这些函数都有两个参数，一个是el(使用自定义指令的元素), 一个是binding(记录自定义指令信息的对象)
    inserted(el, binding) {
      el.focus()
    },
    // 表示自定义指令后面的值更新的时候，自动执行
    update() {
        // console.log(this.scrollHeight , this.scrollTop, '11');
    }
  })

@Component({})
export default class CommissionAdd extends Vue {
    limit = 20
    tableKey = Math.random()
    orderList = []
    orderDialogSelect: any = []

    studentDialog = false
    studentDialogInputValue = ''
    studentDialogTaleData = []
    studentDialogTotal = 0
    studentDialogPage = 1
    orderDialogFilterTotal = 0
    studentDialogTableLoading = false
    studentConfirmList = {
        name:'',
        id: '',
        customerId: null,
    }
    studentDialogSelect = {
        name:'',
        id: '',

        customerId: NaN,

    }

    orderDialog = false
    orderDialogInputValue = ''
    orderDialogTaleData = []
    orderDialogTotal = 0
    orderAllTotal = null
    orderDialogPage = 1
    orderDialogTableLoading = false
    orderDialogSelectTable = []
    // commission_totals = 0
    tableData = []
    formData = {
        studentName: '',
        studentContract: '0',
        agencyContract: '0',
        date: new Date(),
        directorUserId: UserModule.userId || '',
        deparment: '',
        deparmentId: NaN,
        remark: '',
    }
    payInfo: any = {
        name: '',
        cardNum: '',
        branch: '',
        type: '',
        page: 1,
        limit: 20,
        id: '',
    }
    moneyCertificatesArr = []
    fileList = []
    fileList1 = []
    disabledButton = false
    saveDraftDialogShow = false
    errorDialogShow = false
    isDraft = '0'

    backMoneyId: number = null
    orderId: number = null
    editUserName = '' // 编辑的时候使用
    editCreatedAt: Date = null // 编辑的时候用来返显
    draftId: number = null // 草稿id
    backMoneyStatus = ''

    newAccountDialog = false //新增收款账户
    accountTypeList = [
        {value: 'PUBLIC', label: '对公账户'},
        {value: 'PERSONAL', label: '个人账户'},
    ]
    // typeOwnerList = [
    //     {value: 1, label: '个人'},
    //     {value: 2, label: '企业'},
    // ]
    type = '' //账户类型
    // typeOwner = '' //所有者类型
    name = '' //开户名称
    cardNum = '' //银行卡号
    branch = '' //开户网点
    phoneNo = '' //手机号
    certificateNo = '' // 身份证号
    payeeInfoId = '' //新建返佣需要
    formRule = {
        studentName: [{required: true, message: '请选择合作伙伴', trigger: ['change', 'blur']}],
        name: [{ required: true, message: '请选择开户名称', trigger:['change', 'blur']}],
        cardNum: [{ required: true, message: '请选择银行卡号', trigger: ['change', 'blur'] }],
    }
    searchName: any =null //开户名称
    searchCardName: any =null //银行卡号
    payInfoLoading = false
    payeeInfoList = [] // 开户名称数据
    total: 0
    searchBranchName: any =null //开户网点
    branchInfoList = [] // 开户网点数据
    branchPage = 1
    branchLimit = 20
    previewVisible = false
    previewPath = ''
    previewName = ''
    // isReadonly  = false
    timer  = null
    timernew  = null
    syncDialogVisible = false
    msg = ''

    get userName() {
        return UserModule.userName
    }

    get userList() {
        return UserModule.userList
    }

    get directorUserId() {
        return UserModule.userId
    }
    // 佣金合计 = 返佣金额 + 额外佣金
    get commission_totals() {
        let num = 0
        this.tableData.forEach(item => num += Number(item.priceSum))
        return num
    }
    get orderAllPrice() {
        let num = 0
        this.tableData.forEach(item => num += Number(item.price))
        return num
    }

    get needBackMoney() {
        let num = 0
        this.tableData.forEach(item => num += Number(item.needBackMoney))
        return num
    }

    get thisBackMoney() {
        let num = 0
        this.tableData.forEach(item => num += Number(item.thisBackMoney))
        return num
    }

    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }
    get moneyCertificatesUrl() {//打款
        return this.moneyCertificatesArr.map(item => item.url)
    }
    created() {
        if(this.$route.query.orderId) {
            this.orderId = Number(this.$route.query.orderId)
            this.getFinanceBackMoneyInfoById()
        }

        if(this.$route.query.backMoneyId) {
            this.backMoneyId = Number(this.$route.query.backMoneyId)
        }

        if(this.$route.query.draftId){
            this.draftId = Number(this.$route.query.draftId)
            this.getDraftById()
        }

        if(this.$route.query.status) this.backMoneyStatus = this.$route.query.status as string
        this.payInfoList() //开户名称
    }

    menuBtn = menuBtn

    clickNewAccount(){
        this.newAccountDialog = true
        this.getBranchList();
    }
    // 开户网点
    async getBranchList() {
        let objs = {
            name: this.searchBranchName,
            page: this.branchPage,
            limit: this.branchLimit,
        }
        const data: any = await getBranchList(delNullProperty(objs))
        this.branchInfoList = [...this.branchInfoList, ...data.branchList]
        let result = []
        let obj = {}
        for(let i =0; i<this.branchInfoList.length; i++){
            if(!obj[this.branchInfoList[i].name]){
                result.push(this.branchInfoList[i]);
                obj[this.branchInfoList[i].name] = true;
            }
        }
        this.branchInfoList = result
    }
    async handleBranchInfo(){
        if((this.branchInfoList.length == 0 || !this.searchBranchName) && !this.branch){
            this.searchBranchName = null
            this.branchPage = 1
            const result: any = await getBranchList({page: this.branchPage, name: this.searchBranchName })
            this.branchInfoList = result.branchList
        }
        if(this.branch){
            this.branchInfoList = []
            this.branchPage = 1
            const result: any = await getBranchList({page: this.branchPage, name: this.branch })
            this.branchInfoList = result.branchList
        }
    }
    async handleRemoteBranch (query: any) {
        this.searchBranchName = query.trim();
        this.branchPage = 1
        this.branchLimit = 20
        if (query !== '') {
            const result: any = await getBranchList({page: this.branchPage,  name: query })
            this.branchInfoList = result.branchList
        } else {
          this.branchInfoList = []
          this.getBranchList();
        }
    }
    handleBranchLoadmore() {
        this.branchPage ++
        this.getBranchList();
    }
    handleClearBranch() {
        this.searchBranchName = null
        this.branch = ''
        this.branchPage = 1
        this.getBranchList()
    }
    handleBranchChange (val) {
        this.branch = val
    }

    // 开户名称列表
    async payInfoList() {
        let objs = {
            name: this.searchName,
            cardNum: this.searchCardName,
            page: this.payInfo.page,
            limit: this.payInfo.limit,
        }
        const data: any = await payInfoList(delNullProperty(objs))
        this.payeeInfoList = [...this.payeeInfoList, ...data.payeeInfoList]
        let result = []
        let obj = {}
        for(let i =0; i<this.payeeInfoList.length; i++){
            if(!obj[this.payeeInfoList[i].name]){
                result.push(this.payeeInfoList[i]);
                obj[this.payeeInfoList[i].name] = true;
            }
        }
        this.payeeInfoList = result
    }
    async handlePayInfo(){
        if((this.payeeInfoList.length == 0 || !this.searchName) && !this.payInfo.name){
            this.searchName = null
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.searchName })
            this.payeeInfoList = result.payeeInfoList
        }
        if(this.payInfo.name){
            this.payeeInfoList = []
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page,  name: this.searchName })
            this.payeeInfoList = result.payeeInfoList
        }
    }
    async handleRemotePayInfo (query: any) {
        this.searchName = query.trim();
        this.payInfo.page = 1
        this.payInfo.limit = 20
        if (query !== '') {
            const result: any = await payInfoList({page: this.payInfo.page,  name: query })
            this.payeeInfoList = result.payeeInfoList
        } else {
          this.payeeInfoList = []
            this.payInfoList();
        }
    }
    handlePayInfoLoadmore() {
        this.payInfo.page++
        this.payInfoList();
    }
    handleClearPayInfo() {
        this.searchName = null
        this.payInfo.cardNum = ''
        this.payInfo.branch = ''
        this.payInfo.id = ''
        this.payInfo.type = ''
        this.payInfo.page = 1
        this.payInfo.certificateNo = ''
        this.payInfo.phoneNo = ''
        this.payInfoList()
    }
    closeSyncDialog(){
        this.syncDialogVisible = false
    }
    // 开户名称
    handlePayInfoChange (item) {
        this.msg = item.message
        if(item.message){
            this.syncDialogVisible = true
        }
        const indexId = item.id
        let obj = this.payeeInfoList.find((item,index)=> item.id === indexId)
        this.payInfo.name = obj.name
        this.payInfo.cardNum = obj.cardNum
        this.payInfo.branch = obj.branch
        this.payInfo.id = obj.id
        this.payInfo.payeeInfoId = obj.id
        this.payInfo.type = obj.type
        this.payInfo.certificateNo = obj.certificateNo;
        this.payInfo.phoneNo = obj.phoneNo;
    }
    // 银行卡号
    async handlePayCardInfo(){
        if((this.payeeInfoList.length == 0 || !this.searchCardName) && !this.payInfo.cardNum){
            this.searchCardName = null
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page, cardNum: this.searchCardName })
            this.payeeInfoList = result.payeeInfoList
        }
        if(this.payInfo.cardNum){
            this.payeeInfoList = []
            this.payInfo.page = 1
            const result: any = await payInfoList({page: this.payInfo.page, cardNum: this.searchCardName })
            this.payeeInfoList = result.payeeInfoList
        }
    }
    async handleRemotePayCard (query: any) {
        this.searchCardName = query
        this.payInfo.page = 1
        if (query !== '') {
            const result: any = await payInfoList({page: this.payInfo.page, cardNum: query })
            this.payeeInfoList = result.payeeInfoList
        } else {
          this.payeeInfoList = []
            this.payInfoList();
        }
    }
    handlePayCardLoadmore() {
        this.payInfo.page++
        this.payInfoList();
    }
    handleClearPayCard() {
        this.payInfo.name = ''
        this.searchCardName = null
        this.payInfo.branch = ''
        this.payInfo.id = ''
        this.payInfo.type = ''
        this.payInfo.page = 1
        this.payInfo.phoneNo = ''
        this.payInfo.certificateNo = ''
        this.payInfoList()
    }

    // 银行卡号
    handlePayChangeCard (item) {
        this.msg = item.message
        if(item.message){
            this.syncDialogVisible = true
        }
        const indexId = item.id
        let obj = this.payeeInfoList.find((item,index)=> item.id === indexId)
        this.payInfo.name = obj.name
        this.payInfo.cardNum = obj.cardNum
        this.payInfo.branch = obj.branch
        this.payInfo.id = obj.id
        this.payInfo.payeeInfoId = obj.id
        this.payInfo.type = obj.type
        this.payInfo.certificateNo = obj.certificateNo;
        this.payInfo.phoneNo = obj.phoneNo;
    }
    doCancel(){
        this.type = ''
        this.name = ''
        this.cardNum = ''
        this.branch = ''
        this.certificateNo = ''
        this.phoneNo = ''
        this.newAccountDialog = false
    }
    // 新增账户确认
    async handleConfirmAccount() {
        if (this.type === '' ||  this.name === ''|| this.cardNum === ''|| this.branch === '') {
            this.$message.error(`请将${this.type === '' ? '账户类型，' : ''}${this.name === '' ? '开户名称，' : ''}${this.cardNum === '' ? '银行卡号，' : ''}${this.branch === '' ? '开户网点，' : ''}填写完整`)
            return
        }
        if((this.type === 'PERSONAL'&&this.certificateNo=='')|| (this.type === 'PERSONAL'&&this.phoneNo=='')){
            this.$message.error(`请将${this.certificateNo === '' ? '身份证号，' : ''}${this.phoneNo === '' ? '手机号，' : ''}填写完整`)
            return
        }
        const obj = {
            type: this.type,
            name: this.name,
            cardNum: this.cardNum,
            branch: this.branch,
            certificateNo: this.certificateNo,
            phoneNo: this.phoneNo,
        }
        const { payeeInfoId } = await setPayeeInfo(delNullProperty(obj)) as unknown as { payeeInfoId: string}
        this.payInfo.id = payeeInfoId
        this.payInfo.name = this.name
        this.payInfo.cardNum = this.cardNum
        this.payInfo.branch = this.branch
        this.payInfo.certificateNo = this.certificateNo
        this.payInfo.phoneNo = this.phoneNo
        this.payInfo.type = this.type && this.type == 'PUBLIC' ? '对公账户' : this.type && this.type == 'PERSONAL' ? '个人账户': ''
        this.newAccountDialog = false
    }

    handleStudentRowClick(row){
        (this.$refs.studentDialogTable as HTMLFormElement).toggleRowSelection(row)
    }
    handleOrderRowClick(row){
        if(row.isSelect == true){  //可勾选
            (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
        }
    }

    async getFinanceBackMoneyInfoById() {
        const data: any = await getFinanceBackMoneyInfoById({ mainPart: '0', id: this.orderId })
        const { financeBackMoneyInfo } = data
        this.formData.studentName = financeBackMoneyInfo.customerName

        this.tableData.push({
            customerName: financeBackMoneyInfo.customerName,
            code: financeBackMoneyInfo.code,
            souCourseName: financeBackMoneyInfo.souCourseName,
            souCourseSchoolBegin: financeBackMoneyInfo.souCourseSchoolBegin,
            price: financeBackMoneyInfo.price,
            backMoney: financeBackMoneyInfo.backMoney,
            needBackMoney: financeBackMoneyInfo.needBackMoney,
            thisBackMoney: 0,
            oldThisBackMoney: 0,
            id: this.orderId
        })
    }

    async directorUserIdChange() {
        const data: any = await getDepartmentByUserId(this.formData.directorUserId)
        this.formData.deparmentId = data.departmentId
        this.formData.deparment = data.departmentName
    }

    async getFinanceOrderMarketCooperationList() {
        this.studentDialogTableLoading = true
        const data: any = await getFinanceOrderMarketCooperationList({ marketCooperationName: this.studentDialogInputValue, page: this.studentDialogPage, limit: 20 })
        this.studentDialogTaleData = data.marketCooperationList
        this.studentDialogTotal = data.allNum
        this.studentDialogTableLoading = false
    }


    // 获取订单列表
    async getFinanceOrderByMarketCooperationId() {
        const marketId = this.studentDialogSelect.id
        this.orderDialogTableLoading = true

        // 发请求拿到数据并暂存全部数据
        const obj = {
            mainPart: '1',
            marketCooperationId: marketId,
            customerName: this.orderDialogInputValue,
            page: this.orderDialogPage,
            limit: this.limit
        }
        const data: any = await getFinanceOrderByMarketCooperationId(delNullProperty(obj))

        this.orderDialogTaleData =  data.financeOrderList
        this.orderDialogTotal = data.allNum;
        this.orderDialogTableLoading = false
        // this.isReadonly = false

    }

    handleSizeChange(val) {
        this.limit = val
        this.getFinanceOrderByMarketCooperationId()
    }
    orderDialogPageChange(page) {
        this.orderDialogPage = page
        this.getFinanceOrderByMarketCooperationId()
    }


    async getDraftById() {
        const data: any = await getDraftById(this.draftId)
        const { result } = data

        this.editUserName = result.createdUserRealName
        this.editCreatedAt = new Date(result.createdAt)

        // this.formData.backMoneyAccount = result.account
        this.formData.date = new Date(result.backMoneyAt)
        this.formData.directorUserId = result.directorUserId
        this.formData.studentName = result.customerOrCooperationName
        this.formData.deparment = result.directorDepartmentlName
        this.formData.deparmentId = result.directorDepartmentId

        this.tableData = result.financeBackMoneyDetailList.map(item => {
            return {
                customerName: item.customerName,
                code: item.code,
                souCourseName: item.souCourseName,
                souCourseSchoolBegin: item.souCourseSchoolBegin,
                price: item.price,
                backMoney: item.backMoney,
                needBackMoney: item.needBackMoney,
                thisBackMoney: item.thisTimePrice,
                oldThisBackMoney: 0,
                id: item.financeOrderId
            }
        })

        this.fileList = result.financeBackMoneyProofList

    }

    clickSubmintButton() {
        // if(!this.formData.studentName) { this.$message.error('请选择合作伙伴'); return }
        const obj = {
            marketCooperationId: Number(this.studentDialogSelect.id),   //合作伙伴id
            isBackStudentContract: this.formData.studentContract,  //是否交回学生合同 允许值: '0-否', '1-是'
            isBackAgentContract: this.formData.agencyContract,  //是否交回代理合同 允许值: '0-否', '1-是'
            financeCommissionDetailList: [],//返佣详情
            financeCommissionProofList: [],//转款凭证
            directorUserId: this.formData.directorUserId,//负责人id
            isDraft: this.isDraft,  //具体操作 允许值: 0-提交, 1-存草稿
            remark: this.formData.remark,//备注
            payeeInfoId: '', //易快报收款账户id
        }
        obj.financeCommissionDetailList = this.tableData.map(item => ({ financeOrderId: item.id, extraPrice: String(item.extraPrice) }))
        obj.financeCommissionProofList = this.fileList1.map(item => ({ name: item.name, url: String(item.url) }))
        for(const key in obj) {
            if(obj[key].length === 0 || !obj[key]) {
                delete obj[key]
            }
        }
        obj.payeeInfoId = this.payInfo.id;



        let flag = true;
        (this.$refs.formOldRef as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false;
            }
        });
        (this.$refs.formRef as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false;
            }
        })

        if (flag) {
            if(this.tableData.length === 0) { this.$message.error('请选择订单'); return }
            // obj.financeBackMoneyDetailList =  obj.financeBackMoneyDetailList.filter(item => item.thisTimePrice > 0)
            if (!this.payInfo.name ||  !this.payInfo.cardNum) {
                this.$message.error('请将收款信息填写完整')
                return
            }
            this.disabledButton = true;
            setFinanceCommission(obj).then(() => {
                this.$message.success(`${this.isDraft === '0' ? '新建成功' : '已保存到草稿箱'}`)
                setTimeout(() => {
                    this.closePage()
                    // this.$router.go(-1)
                }, 1500)
                this.saveDraftDialogShow = false
            }).catch((err: Error) => {
                if (err) {
                    this.disabledButton = false
                }
                if (err.message === '审批流报错') {
                    this.errorDialogShow = true
                }
            })
        }
    }

    choiceStudent(e) {
        this.studentDialogPage = 1
        this.studentDialogInputValue = ''
        this.studentDialog = true
        this.getFinanceOrderMarketCooperationList()
        e.target.blur()
    }

    studentDialogConfirm() {
        this.studentConfirmList = this.studentDialogSelect
        this.formData.studentName = this.studentDialogSelect.name
        this.studentDialog = false
        this.studentDialogInputValue = ''
        this.tableData = []
        const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
        orderDialogTable.clearSelection()
    }
    // 合作列表取消
    handleStudentDialog(){
        if(!this.studentConfirmList || ( this.studentConfirmList.customerId != this.studentDialogSelect.customerId )){
            const studentTable = this.$refs.studentDialogTable as HTMLFormElement
            studentTable.clearSelection()
            studentTable.toggleRowSelection(this.studentConfirmList,true)
        }
        if(this.studentConfirmList){
            const studentTable = this.$refs.studentDialogTable as HTMLFormElement
            studentTable.toggleRowSelection(this.studentConfirmList,true)
        }
        this.studentDialog = false
    }

    studentDialogSelectionChange(selectionArr: any[]) {
        if(selectionArr.length > 0) {
            // this.$nextTick(function() {
            //     this.studentDialogSelect = JSON.parse(JSON.stringify(selectionArr[0]))
            //     this.studentDialogTaleData.forEach(row => {
            //         if (selectionArr.includes(row.id)) {
            //             const studentTable = this.$refs.studentDialogTable as HTMLFormElement
            //             studentTable.toggleRowSelection(row, true)
            //         }
            //     });
            // });
            this.studentDialogSelect = JSON.parse(JSON.stringify(selectionArr[0]))
            if(selectionArr.length > 1) {
                const studentTable = this.$refs.studentDialogTable as HTMLFormElement
                studentTable.clearSelection()
                studentTable.toggleRowSelection(selectionArr.pop())
            }
        } else {
            for(const key in this.studentDialogSelect) {
                this.studentDialogSelect[key] = null
            }
        }
    }

    studentDialogPageChange(page: number) {
        this.studentDialogPage = page
        this.getFinanceOrderMarketCooperationList()
    }

    clickAddOrder() {
        if(!this.formData.studentName) {
            this.$message.error('请选择合作伙伴')
            return
        }
        this.orderDialog =  true
        this.orderDialogPage = 1
        this.orderDialogInputValue = ''
        this.getFinanceOrderByMarketCooperationId()
        this.defaultChecked()
    }

    defaultChecked(){
        this.$nextTick(() => {
            let order = (this.$refs.orderDialogTable as HTMLFormElement)
            order.clearSelection();
            this.tableData.forEach(row => {
                order.toggleRowSelection(row, true)
            })
        })
    }
    // 订单列表取消
    handleOrderDialog(){
        this.orderDialogSelectTable.map(item => {
            this.tableData.map(items => {
                if(item.id !== items.id){
                    const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
                    orderDialogTable.clearSelection()
                }
            })
        })

        if(this.tableData.length > 0){
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            this.tableData.forEach(row => {
                orderDialogTable.toggleRowSelection(row,true)
            });
        }else {
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            orderDialogTable.clearSelection()
        }
        this.orderDialog = false
    }
    orderDialogConfirm() {
        const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
        this.tableData = []
        orderDialogTable.selection.forEach(item => {
            this.tableData.push({
                ...item,
                extraPrice: 0,
                priceSum: Number(item.commissionPrice)
            })
        })
        orderDialogTable.clearSelection();
        this.orderDialog = false
    }

    orderDialogSelectionChange(selectionArr: any[]) {
        this.orderDialogSelectTable = selectionArr
    }


    thisBackMoneyChange(row, val){
        // 佣金总计 = 返佣金额 + 额外佣金
        row.priceSum = Math.round((Number(row.commissionPrice) + Number(val)) * 100) / 100
    }

    clickDelOrder(row) {
        this.tableData = this.tableData.filter(item => item.id !== row.id)
        this.orderDialogSelectTable = this.orderDialogSelectTable.filter(item => item.id !== row.id)
        this.tableData.forEach(row => {
            (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row, true)
        })
    }

    clickSavaDraftButton() {
        this.isDraft = '1'
        this.saveDraftDialogShow = true
    }
    saveDraftDialogConfirm() {
        this.clickSubmintButton()
    }
    saveDraftDialogCancel() {
        this.isDraft = '0'
        this.saveDraftDialogShow = false
    }

    pageChange(page: number) {
        if (this.timernew !== null) clearTimeout(this.timernew)
        this.timernew = setTimeout(() => {
            this.studentDialogPage = page
            this.clickStudentDialogFilter()
        }, 1000)
    }

    async clickStudentDialogFilter() {

        this.studentDialogTableLoading = true

        const obj = {
            marketCooperationName: this.studentDialogInputValue,
            page: this.studentDialogPage,
            limit: 20
        }
        const data: any = await getFinanceOrderMarketCooperationList(delNullProperty(obj))
        this.studentDialogTaleData = data.marketCooperationList.filter(item => item.name.includes(this.studentDialogInputValue))
        this.studentDialogTotal = data.allNum
        this.studentDialogTableLoading = false
        // this.isReadonly = false

    }



    clickOrderDialogFilter(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.orderDialogPage = page
            this.getFinanceOrderByMarketCooperationId()
        }, 1000)
    }

    setDraftById(isSubmit: string) {
        const obj = {
            mainPart: '0',
            // customerId: this.studentDialogSelect.customerId,
            // customerType: this.studentDialogSelect.customerType,
            // account: this.formData.backMoneyAccount,
            // backMoneyAt: formatDate('yyyy-MM-dd', new Date(this.formData.date)),
            financeBackMoneyDetailList: [],
            financeBackMoneyProofList: this.fileList,
            directorUserId: this.formData.directorUserId,
        }
        obj.financeBackMoneyDetailList = this.tableData.map(item => ({ financeOrderId: item.id, thisTimePrice: item.thisBackMoney }))
        setDraftById({
            id: this.draftId,
            form: obj,
            isSubmit
        }).then(res => {
            this.$message.success(`${isSubmit === '0' ? '保存成功，页面即将关闭' : '提交成功，页面即将关闭'}`)
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            if(err.message == '审批流报错') {
                this.errorDialogShow = true
            }
            this.disabledButton = false
        })
    }

    orderDialogTableSelect(row,index) {
        if(row.isSelect == false){
            return false  //不可勾选
        }else{
          return true  //可勾选
        }
        // return row.selectDisabled && row.needBackMoney !== 0
    }

    uploadSuccess(res) {
        const { data } = res
        this.$message.success('上传成功')
        this.fileList.push({ name: data.name, url: data.ossUrl })
    }
    uploadSuccess1(res) {
        const { data } = res
        this.$message.success('上传成功')
        this.fileList1.push({ name: data.name, url: data.ossUrl })
    }
    uploadError() {
        this.$message.error('上传失败')
    }
    uploadError1() {
        this.$message.error('上传失败')
    }

    handlePreview(file) {
        this.previewPath = file.url
        this.previewName = file.name
        this.previewVisible = true
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }
    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }
    handleUploadRemove1(file) {
        this.fileList1 = this.fileList1.filter(item => item.uid !== file.uid)
    }

    closePage() {
        window.close()
    }

    changeType(val){
        this.certificateNo = ''
        this.phoneNo = ''
    }

    @Watch('directorUserId')
    handle(userId: string) {
        this.formData.directorUserId = userId
        if(userId !== '1') {
            this.directorUserIdChange()
        }
    }

}
